/**
 * Detect the platform/CMS a website is built on
 * This is a simple detection based on common patterns
 * Can be enhanced with actual HTTP header checks in the future
 */
export function detectPlatform(url) {
  if (!url) return null;
  
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname.toLowerCase();
    const pathname = urlObj.pathname.toLowerCase();
    
    // WordPress detection patterns
    // Common WordPress paths and patterns
    if (
      pathname.includes('/wp-content') ||
      pathname.includes('/wp-admin') ||
      pathname.includes('/wp-includes') ||
      hostname.includes('wordpress.com') ||
      hostname.includes('.wordpress.')
    ) {
      return {
        name: 'WordPress',
        icon: 'wordpress',
        color: '#21759b'
      };
    }
    
    // Shopify detection
    if (
      hostname.includes('.myshopify.com') ||
      (pathname.includes('/admin') && hostname.includes('shopify'))
    ) {
      return {
        name: 'Shopify',
        icon: 'shopify',
        color: '#96bf48'
      };
    }
    
    // Squarespace detection
    if (hostname.includes('.squarespace.com')) {
      return {
        name: 'Squarespace',
        icon: 'squarespace',
        color: '#000000'
      };
    }
    
    // Wix detection
    if (hostname.includes('.wixsite.com') || hostname.includes('.wix.com')) {
      return {
        name: 'Wix',
        icon: 'wix',
        color: '#faad4d'
      };
    }
    
    // Drupal detection
    if (pathname.includes('/sites/default') || pathname.includes('/modules/')) {
      return {
        name: 'Drupal',
        icon: 'drupal',
        color: '#0678be'
      };
    }
    
    // Joomla detection
    if (pathname.includes('/administrator') || pathname.includes('/components/')) {
      return {
        name: 'Joomla',
        icon: 'joomla',
        color: '#5091cd'
      };
    }
    
    // React/Next.js - hard to detect without headers, but we can check for common patterns
    // This is less reliable, so we'll skip it for now
    
    // If no platform detected, return null
    return null;
  } catch (e) {
    return null;
  }
}

/**
 * Get platform icon component (using Material Icons or simple text)
 */
export function getPlatformIcon(platform) {
  if (!platform) return null;
  
  // For now, we'll use text-based icons or Material Icons
  // WordPress uses 'code' or we can use a custom SVG
  const iconMap = {
    wordpress: 'code', // Material Icons doesn't have WordPress, using code as placeholder
    shopify: 'store',
    squarespace: 'web',
    wix: 'web',
    drupal: 'code',
    joomla: 'code'
  };
  
  return iconMap[platform.icon] || 'web';
}

